import axios from 'axios';

const loginAPI = async function(url, username, password) {

    let formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('grant_type', 'password');
    
    try {
        return await axios({
            url,
            method: 'POST',
            headers: {
                Authorization: process.env.VUE_APP_API_TOKEN
            },
            data: formData

        })
    } catch (e) {
        return e.response
    }


}
export {
    loginAPI
}